import React from "react";
// CSS;
import "../../assets/bootstrap/bootstrap.min.css";
// import "../../App.css";
import "toastr/build/toastr.min.css";
// import "react-day-picker/lib/style.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../../assets/css/style.css";
const CssLoader = () => <></>;
export default CssLoader;
